module.exports = __webpack_public_path__ + "img/vision.087b495f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vision.jpg
// module id = NR2d
// module chunks = 0